import { useMemo } from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import { FuelRegisters } from 'components/direct-sales/meter-reads/components/FuelRegisters';
import { useMeterRead } from 'components/direct-sales/meter-reads/hooks/useMeterRead';
import { selectMeterReads } from 'state/meter-reads/move-in-meter-read-slice';
import { selectFuelType } from 'state/fuel-type/fuel-type-slice';
import {
  selectElectricityRegisters,
  selectGasRegisters
} from 'state/move-in-date/move-in-date-slice';
import {
  METER_READS_ELECTRICITY_MAX_DIGITS,
  METER_READS_GAS_MAX_DIGITS
} from 'config/app-config';

export const MeterReadsForm = () => {
  const { handleReadingChange } = useMeterRead();
  const meterReads = useSelector(selectMeterReads, shallowEqual);
  const { gas, electric } = useSelector(selectFuelType, shallowEqual);
  const electricityRegisters = useSelector(
    selectElectricityRegisters,
    shallowEqual
  );
  const gasRegisters = useSelector(selectGasRegisters, shallowEqual);
  const isElectric = electric && !!electricityRegisters?.length;
  const isGas = gas && !!gasRegisters?.length;

  return useMemo(() => {
    return (
      <>
        {isElectric && (
          <FuelRegisters
            fuelType="electricity"
            registers={electricityRegisters}
            meterReads={meterReads}
            onChange={handleReadingChange}
            defaultDigits={METER_READS_ELECTRICITY_MAX_DIGITS}
          />
        )}
        {isGas && (
          <FuelRegisters
            fuelType="gas"
            registers={gasRegisters}
            meterReads={meterReads}
            onChange={handleReadingChange}
            defaultDigits={METER_READS_GAS_MAX_DIGITS}
          />
        )}
      </>
    );
  }, [
    isElectric,
    electricityRegisters,
    meterReads,
    handleReadingChange,
    isGas,
    gasRegisters
  ]);
};
